/** One cell, quoted, with embedded quotes doubled and formula-looking text neutralised. Missing values are empty. */
export function csvCell(value: unknown): string {
  const raw = value === null || value === undefined ? '' : String(value);
  // A text value a spreadsheet would read as a formula gets a leading apostrophe. Real numbers stay as they are.
  const text = typeof value === 'string' && /^[=+\-@\t\r]/.test(raw) ? `'${raw}` : raw;
  return `"${text.replace(/"/g, '""')}"`;
}

/** Header row plus data rows as CSV text. */
export function toCsv(headers: string[], rows: unknown[][]): string {
  return [headers, ...rows].map(row => row.map(csvCell).join(',')).join('\n');
}
